import { useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/shallow";

import { ActivityCompareStoreType } from "./activity_compare_store.types";
import { ActivityCompareStoreContext } from "./activity_compare_store_context";

export const useActivityCompareStore = <U>(selector: (state: ActivityCompareStoreType) => U) => {
  const store = useContext(ActivityCompareStoreContext);
  return useStore(store, useShallow(selector));
};

export const useActivityCompareStoreActions = () => {
  const store = useContext(ActivityCompareStoreContext);
  return useStore(store, (state) => state.actions);
};
